import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Col, Row, FormControl, Button } from 'react-bootstrap';
import { mapValues } from 'lodash';

import { modals as modalConstants } from '../helpers';
import MetricsTableComponent from './MetricsTableComponent';

export const Checkbox = ({
  typesChecked,
  type,
  onChange
}) => (
  <div>
    <input
      type="checkbox"
      style={{ marginRight: '15px' }}
      checked={typesChecked[type]}
      onChange={e => onChange({
        ...typesChecked,
        [type]: e.target.checked
      })}
    />
    {type.toUpperCase()}
  </div>
);
Checkbox.propTypes = {
  typesChecked: PropTypes.shape({
    ncfHits: PropTypes.bool,
    ccfHits: PropTypes.bool,
    ncfDuration: PropTypes.bool,
    ccfDuration: PropTypes.bool,
    ncfSource: PropTypes.bool,
    ncfSourceAttribute: PropTypes.bool
  }).isRequired,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export const createCheckboxes = (
  createTypes,
  typesChecked,
  onTypesCheckChange,
) => {
  return createTypes
    .map((type, index) =>
      <Checkbox
        key={index}
        typesChecked={typesChecked}
        type={type}
        onChange={onTypesCheckChange}
      />);
};

const JiraConfirmModalComponent = ({
  visible,
  showSources,
  issue,
  setIssue,
  onHide,
  onConfirm,
  metrics,
  ccfNcfBuildOrder,
  typesChecked,
  onTypesCheckChange,
  artifact,
  delta
}) => {
  const firstRowTypes = [
    ...([ ccfNcfBuildOrder.main, ccfNcfBuildOrder.other ]
      .filter(x => x)
      .map(x => `${x}Duration`)),
    ...([ ccfNcfBuildOrder.main, ccfNcfBuildOrder.other ]
      .filter(x => x)
      .map(x => `${x}Hits`)),
  ];
  const firstRowBoxes = createCheckboxes(
    firstRowTypes,
    typesChecked,
    onTypesCheckChange
  ).map((checkbox, index) => <Col key={index} md={2}>{checkbox}</Col>);

  const secondRowBoxes = createCheckboxes(
    [
      modalConstants.jiraConfirmTypes.NCFSOURCE,
      modalConstants.jiraConfirmTypes.NCFSOURCEATTRIBUTE
    ],
    typesChecked,
    onTypesCheckChange
  ).map((checkbox, index) => <Col key={index} md={2}>{checkbox}</Col>);

  return (
    <Modal
      id="jira-confirm-modal"
      show={visible}
      onHide={onHide}
      dialogClassName="modal-wide"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Confirm Expected Hits{ artifact ? ' for Artifact ' + artifact : ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={12}>
            <MetricsTableComponent
              metrics={metrics}
              ccfNcfBuildOrder={ccfNcfBuildOrder}
              disableImageLink
              showSources={showSources && !artifact}
              art={artifact}
              delta={delta}
            />
          </Col>
        </Row>
        <Row style={{ textAlign: 'center', paddingBottom: '15px' }}>
          {
            (showSources || ccfNcfBuildOrder.other) &&
            <Col md={12}>Submit changes for:</Col>
          }
        </Row>
        <Row>
          {firstRowBoxes}
        </Row>
        <Row>
          {secondRowBoxes}
        </Row>
        <Row>
          <Col md={1}>
            <Button
              id={'check-all-btn'}
              onClick={() => onTypesCheckChange(mapValues(typesChecked, () => true))}
            >
              Check All
            </Button>
          </Col>
          <Col md={1}>
            <Button
              id={'clear-all-btn'}
              onClick={() => onTypesCheckChange(mapValues(typesChecked, () => false))}
            >
              Clear All
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormControl
              id="issue-input"
              type="text"
              value={issue}
              onChange={e => setIssue(e.target.value)}
              placeholder="Optional Related Issue (ex. AXP-123)"
            />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={6}>
            <Button
              id="jira-confirm-button"
              bsStyle="warning"
              block
              onClick={onConfirm}
            >
              Confirm
            </Button>
          </Col>
          <Col md={6}>
            <Button id="jira-cancel-button" block onClick={onHide}>Cancel</Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

JiraConfirmModalComponent.propTypes = {
  visible: PropTypes.bool,
  showSources: PropTypes.bool,
  issue: PropTypes.string.isRequired,
  setIssue: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  metrics: PropTypes.array.isRequired,
  ccfNcfBuildOrder: PropTypes.shape({
    main: PropTypes.string.isRequired,
    other: PropTypes.string
  }).isRequired,
  typesChecked: PropTypes.shape({
    ncf: PropTypes.bool,
    ccf: PropTypes.bool
  }).isRequired,
  onTypesCheckChange: PropTypes.func.isRequired,
  artifact: PropTypes.string,
  delta: PropTypes.number
};

export default JiraConfirmModalComponent;


// WEBPACK FOOTER //
// src/Components/JiraConfirmModalComponent.jsx